"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddableVizClientLineagePanel = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var shared_urls_1 = require("@tableau/shared-urls");
var React = require("react");
var ViewDetailsByPathWrapper_1 = require("./ViewDetailsByPathWrapper");
var EmbeddableVizClientLineagePanel = /** @class */ (function (_super) {
    __extends(EmbeddableVizClientLineagePanel, _super);
    function EmbeddableVizClientLineagePanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmbeddableVizClientLineagePanel.prototype.render = function () {
        return (React.createElement(data_catalog_shared_1.VizClientDataCatalogProvider, { client: this.props.client, siteUrls: new shared_urls_1.SiteUrls({
                siteUrlName: this.props.siteUrlName,
                queryString: this.props.queryString,
            }), featureFlags: {
                metricsDataCatalogEnabled: false,
                writableFieldDescriptionsEnabled: this.props
                    .writableFieldDescriptionsEnabled,
                markupEditingEnabled: this.props.markupEditingEnabled,
                personalSpaceEnabled: false,
                dqcertificationVisualDesignEnabled: true,
                fieldDescriptionInheritanceLineageEnabled: false,
                incompleteCustomSqlEnabled: false,
                publishedConnectionsLineageEnabled: true,
                databasesInProjectsEnabled: false // flag unused in vizclient
            } },
            React.createElement(ViewDetailsByPathWrapper_1.ViewDetailsByPathWrapper, { viewPath: this.props.sheetPath, testId: this.props.testId, onCloseRequested: this.props.onCloseRequested, lastRefreshKey: this.props.lastRefreshKey, vizPortalWebClientRequester: this.props.vizPortalWebClientRequester })));
    };
    return EmbeddableVizClientLineagePanel;
}(React.Component));
exports.EmbeddableVizClientLineagePanel = EmbeddableVizClientLineagePanel;
//# sourceMappingURL=EmbeddableVizClientLineagePanel.js.map